import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { TbChevronsDown, TbPinnedFilled } from "react-icons/tb";
import { BsPin } from "react-icons/bs";
import { ApolloError } from "@apollo/client";

import { TClip } from "MVVM/@types";
import { IContentItem, IEmptyContentItem } from "MVVM/Views/Homepage/@types";
import { PageableContentFeed } from "MVVM/Views/Homepage/PageableContentFeed";
import { Divider } from "MVVM/Components/Divider";
import { useRecoilValue } from "recoil";
import { PinnedClipsAtom } from "MVVM/State/clip";

const MAX_PINNED = 3;

export const PinnedClips = ({
  isOwnProfile,
  username,
  displayArrows,
  userId,
}: {
  isOwnProfile: boolean;
  username: string;
  displayArrows: boolean;
  userId?: string;
}) => {
  const pinnedClips = useRecoilValue(PinnedClipsAtom);
  const reversedPinnedClips = [...(pinnedClips || [])].reverse();
  const content = reversedPinnedClips?.map((pinnedClip: any) => {
    const thumbnailUrl =
      pinnedClip.thumbnailOverlayUrl ||
      pinnedClip.thumbnailStandardUrl ||
      pinnedClip.thumbnailUrl;
    return {
      clipImageThumb: thumbnailUrl,
      clipSnapshot: pinnedClip.previewUrl,
      previewUrl: pinnedClip.previewUrl,
      thumbnailStandardUrl: pinnedClip.thumbnailStandardUrl || thumbnailUrl,
      thumbnailOverlayUrl: pinnedClip.thumbnailOverlayUrl || thumbnailUrl,
      clipPreviewPath: pinnedClip.previewUrl,
      clipId: pinnedClip.id,
      createdDate: pinnedClip.createdAt,
      shareId: pinnedClip.shareId,
      title: pinnedClip.title,
      type: "clip",
      views: pinnedClip.views,
      hasBeenPinned: pinnedClip.isPinned,
      user: {
        _id: pinnedClip.user._id,
        username: pinnedClip.user.username,
        avatar: pinnedClip.user.avatar,
      },
    } as IContentItem;
  });

  if (isOwnProfile && content?.length < MAX_PINNED) {
    while (content.length < MAX_PINNED) {
      content.push({
        icon: <StyledPin />,
        text: "Hover over a clip in your feed and pin it to add it to your Top Plays.",
        type: "empty",
      } as IEmptyContentItem);
    }
  }

  if (!content.length) return <></>;

  return (
    <>
      <PageableContentFeed
        data={content}
        displayArrows={displayArrows}
        loading={false}
        displayTitle={true}
        scrollable={false}
        title={`${username}'s Top Plays`}
        icon={<FilledPin />}
        isOwnProfile={isOwnProfile}
        navigationContext={{
          type: "pinned-clips",
          metadata: {
            userId,
            tab: "recommended",
          },
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        }}
      />
      <Divider variant="pinnedClipsBottom" mb={6}>
        <Flex alignItems={"center"}>
          <StyledDoubleChevronDown size={24} />
        </Flex>
      </Divider>
    </>
  );
};

const FilledPin = styled(TbPinnedFilled)`
  color: ${({ theme }) => theme.colors.error};
  height: 31px;
  padding-right: 4px;
  margin-bottom: -5px;
`;
const StyledPin = styled(BsPin)`
  width: 20px;
  height: 20px;
`;
const StyledDoubleChevronDown = styled(TbChevronsDown)`
  color: ${({ theme }) => theme.colors.chalk};
`;
